import React from 'react';
import { storiesOf } from '@storybook/react';
import { action } from '@storybook/addon-actions';
import SchedulesForm from './SchedulesForm';
import Notification, { notify } from '../../../common/Notification/Notification';

storiesOf('Advanced Search/Initial Forms/Bankruptcy/Schedules', module)
  .add('View', () => (
    <div className="advanced-search-form">
      <SchedulesForm onSubmit={action('searchGeneral')} onReset={action('resetGeneralSearch')} />
    </div>
  ))
  .add('Search error', () => (
    <div>
      <Notification />
      <SchedulesForm
        onSubmit={(...args) => {
          notify.error('Failed to return Advanced Search results');
          action('searchGeneral')(...args);
        }}
        onReset={action('resetGeneralSearch')}
      />
    </div>
  ));



// WEBPACK FOOTER //
// ./src/components/advancedSearch/initialForms/bankruptcy/SchedulesForm.stories.jsx